import { useToast } from '@/hooks/use-toast';
import { supabase } from '@/lib/supabase';
import { useNavigate } from 'react-router-dom';
import { storePendingDownload } from '@/utils/benchmarkStorage';

export const useDownloadWithAuth = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  
  const executeWithAuth = async (
    downloadFn: () => Promise<void>,
    option: 'single' | 'all'
  ) => {
    // Single downloads don't require authentication
    if (option === 'single') {
      await downloadFn();
      return;
    }

    // Check authentication for "Download All"
    const {
      data: { user },
      error: authError,
    } = await supabase.auth.getUser();

    if (authError || !user) {
      console.log('Auth error or no user for download all:', authError);
      toast({
        title: "Authentication required",
        description: "Please sign in to download all charts",
        variant: "destructive",
      });
      
      // Store pending download info with simplified interface
      storePendingDownload({
        returnUrl: window.location.href,
        downloadType: 'all'
      });
      
      navigate('/login');
      return;
    }

    // User is authenticated, proceed with download
    console.log('Authenticated user for download all:', user.id);
    await downloadFn();
  };
  
  return { executeWithAuth };
}; 